import { render } from "./DogList.vue?vue&type=template&id=89d8e5a0"
import script from "./DogList.vue?vue&type=script&lang=js"
export * from "./DogList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__